<form *ngIf="!isLoading">
  <div class="row mt-3">
    <div class="col" *ngIf="!data.HideLabel">
      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control" [value]="data.Label" readonly />
      </div>
    </div>
    <div class="col" *ngIf="!data.HideDescription">
      <div class="form-group">
        <label>Description</label>
        <textarea type="text" class="form-control" readonly>{{
          data.Description
        }}</textarea>
      </div>
    </div>
    <div class="col" *ngIf="!data.HideQuantity">
      <div class="form-group">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="data.Quantity"
          min="0"
          step="1"
          (input)="updateData()"
        />
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label>Amount</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            *ngIf="data.Dynamic"
            type="number"
            class="form-control"
            [ngModelOptions]="{ standalone: true }"
            (input)="updateData()"
            [(ngModel)]="data.Amount"
          />
          <input
            *ngIf="!data.Dynamic"
            type="number"
            class="form-control"
            [value]="data.Amount.toFixed(2)"
            readonly
          />
        </div>
      </div>
    </div>
  </div>
</form>
